const cfdPriorYearDelinquencyReport = {
  label: "CFD Prior Year Delinquency Report",
  name: "cfdPriorYearDelinquencyReport",
  parameters: [
    {
      name: "currentTaxYear",
      label: "Current Tax Year",
      type: "year",
      defaultValue: "2025",
    },
    {
      name: "countyId",
      label: "County",
      type: "dbfield",
      db: "cfd_nehal",
      table: "County",
      keyField: "CountyId",
      valueField: "Name",
      fields: ["County.CountyId", "County.Name"],
      distinct: true,
      join: {
        Parcel: "CountyId",
      },
      sort: {
        Name: "asc",
      },
    },
  ],
};

export default cfdPriorYearDelinquencyReport;
